import SalesforceRichTextArea from 'components/Generic/Forms/SalesforceIntegratedForms/fieldsTemplates/SalesforceRichTextArea';
import SalesforceConditionalRadioButtons from 'components/Generic/Forms/SalesforceIntegratedForms/fieldsTemplates/SalesforceConditionalRadioButtons';
import SalesforceCheckBox from 'components/Generic/Forms/SalesforceIntegratedForms/fieldsTemplates/SalesforceCheckBox';
import SalesforceInput from 'components/Generic/Forms/SalesforceIntegratedForms/fieldsTemplates/SalesforceInput';
import SalesforceDropdown from 'components/Generic/Forms/SalesforceIntegratedForms/fieldsTemplates/SalesforceDropdown';
import SalesforceRepeatableSubSection from 'components/Generic/Forms/SalesforceIntegratedForms/fieldsTemplates/SalesforceRepeatableSubSection';
import SalesforceAlertMessage from 'components/Generic/Forms/SalesforceIntegratedForms/fieldsTemplates/SalesforceAlertMessage';
import SalesforceDateInput from 'components/Generic/Forms/SalesforceIntegratedForms/fieldsTemplates/SalesforceDateInput';
import SalesforceSortCode from 'components/Generic/Forms/SalesforceIntegratedForms/fieldsTemplates/SalesforceSortCode';
import SalesforceHiddenField from 'components/Generic/Forms/SalesforceIntegratedForms/fieldsTemplates/SalesforceHiddenField';
import { TemplateComponentType } from './TemplateComponentType';

const TEMPLATE_COMPONENTS_BY_NAME: Record<string, TemplateComponentType> = {
  'Salesforce Rich Text Area': SalesforceRichTextArea,
  'Salesforce Conditional Radio Buttons': SalesforceConditionalRadioButtons,
  'Salesforce Check Box': SalesforceCheckBox,
  'Salesforce Input': SalesforceInput,
  'Salesforce Dropdown': SalesforceDropdown,
  'Salesforce Repeatable Sub Section': SalesforceRepeatableSubSection,
  'Salesforce Alert Message': SalesforceAlertMessage,
  'Salesforce Date Input': SalesforceDateInput,
  'Salesforce Sort Code Input': SalesforceSortCode,
  'Salesforce Hidden Field': SalesforceHiddenField,
};

export default TEMPLATE_COMPONENTS_BY_NAME;
